import {
  type TemplateMemberValueColumnDto,
  TemplateMemberValueColumnKind,
} from '@up2stay/up2promo-api-client';

import type { TemplateMemberValueColumn } from '@/core/lib/profile-template-member-values';

export function columnToMemberValuesQuery(
  column: TemplateMemberValueColumn,
): TemplateMemberValueColumnDto {
  switch (column.kind) {
    case 'field':
      return { kind: TemplateMemberValueColumnKind.FIELD, key: column.key };
    case 'social':
      return {
        kind: TemplateMemberValueColumnKind.SOCIAL,
        platform: column.platform,
      };
    case 'moduleEntry':
      return {
        kind: TemplateMemberValueColumnKind.MODULE_ENTRY,
        entryId: column.entryId,
        moduleId: column.moduleId,
      };
    case 'setting':
      return { kind: TemplateMemberValueColumnKind.SETTING, key: column.key };
    default:
      return { kind: TemplateMemberValueColumnKind.FIELD, key: 'jobTitle' };
  }
}

export function profileCellDiffersFromStandard(
  cellValue: string,
  standardValue: string,
): boolean {
  return cellValue.trim() !== standardValue.trim();
}
